<footer class="footer-group d-flex align-items-center fixed-bottom">
    <span class="footer-trademark">Copyright @2022 </span>
    <span class="footer-trademark text-primary">THOT, TotalEnergies Hub Of Technology, </span>
    <span class="footer-trademark">by </span>
    <img class="footer-trademark footer-logo" src="assets/images/pages/footer/TotalEnergies_Logo_GrayScale.png" alt="" />
    <span class="footer-trademark"> All rights reserved</span>
</footer>
